/**
 * Web twin of `UaePassVerificationSheet`.
 *
 * Both shells render the same verification content. Web keeps the centred
 * `WebDialog`, while native uses the established bottom sheet.
 */
import { useTranslation } from 'react-i18next';
import { WebDialog } from '../common/WebDialog.web';
import { UaePassVerificationContent } from './UaePassVerificationContent';

export function UaePassVerificationSheet({
  visible,
  onClose,
  onAfterClose,
}: {
  visible: boolean;
  onClose: () => void;
  onAfterClose?: () => void;
}) {
  const { t } = useTranslation('seeker');

  if (!visible) return null;

  const close = () => {
    onClose();
    onAfterClose?.();
  };

  return (
    <WebDialog
      title={t('jobs.uaePass.title')}
      onClose={close}
      maxWidth={460}
    >
      <UaePassVerificationContent onClose={close} />
    </WebDialog>
  );
}
